import { handleActions } from 'redux-actions';

import { types } from '../constants';

const INITIAL_STATE = {
  openChangePasswordDialog: false,
  userInAuth0: {
    item: {}
  },
  user: {
    item: {},
    isLoading: false,
    errorMessage: ''
  },
  changePasswordRequest: {
    isSaving: false,
    errorMessage: ''
  },
  allUsers: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: '',
    searchTerm: ''
  }
};

const setLoggedInUser = (state, { user }) => {
  return {
    ...state,
    userInAuth0: {
      ...state.userInAuth0,
      item: user
    }
  };
};

const openChangePasswordDialog = (state, { open }) => {
  return {
    ...state,
    openChangePasswordDialog: open
  };
};

const startSendChangePasswordRequest = (state) => {
  return {
    ...state,
    changePasswordRequest: {
      ...state.changePasswordRequest,
      isSaving: true
    }
  };
};

const sendChangePasswordRequestSuccess = (state) => {
  return {
    ...state,
    changePasswordRequest: {
      ...state.changePasswordRequest
    }
  };
};

const sendChangePasswordRequestFailure = (state, { errorMessage }) => {
  return {
    ...state,
    changePasswordRequest: {
      ...state.changePasswordRequest,
      errorMessage
    }
  };
};

const sendChangePasswordRequestFinished = (state) => {
  return {
    ...state,
    changePasswordRequest: {
      ...state.changePasswordRequest,
      isSaving: false
    }
  };
};

const startFetchUserDetails = (state) => {
  return {
    ...state,
    user: {
      ...state.user,
      isLoading: true
    }
  };
};

const fetchUserDetailsSuccess = (state, { user }) => {
  return {
    ...state,
    user: {
      ...state.user,
      item: user
    }
  };
};

const fetchUserDetailsFailure = (state, { errorMessage }) => {
  return {
    ...state,
    user: {
      ...state.user,
      errorMessage
    }
  };
};

const fetchUserDetailsFinished = (state) => {
  return {
    ...state,
    user: {
      ...state.user,
      isLoading: false
    }
  };
};

const startFetchAllUsers = (state) => {
  return {
    ...state,
    allUsers: {
      ...state.allUsers,
      isLoading: true
    }
  };
};

const fetchAllUsersSuccess = (state, { allUsers }) => {
  return {
    ...state,
    allUsers: {
      ...state.allUsers,
      items: allUsers,
      itemsCopy: allUsers
    }
  };
};

const fetchAllUsersFailure = (state, { errorMessage }) => {
  return {
    ...state,
    allUsers: {
      ...state.allUsers,
      errorMessage
    }
  };
};

const fetchAllUsersFinished = (state) => {
  return {
    ...state,
    allUsers: {
      ...state.allUsers,
      isLoading: false
    }
  };
};

const changeSearchTermForAllUsers = (state, { searchTerm }) => {
  let users = state.allUsers.itemsCopy;

  let filteredUsers = users.filter(
    (g) =>
      (g.name && g.name.toLowerCase().includes(searchTerm)) ||
      (g.email && g.email.toLowerCase().includes(searchTerm))
  );

  return {
    ...state,
    allUsers: {
      ...state.allUsers,
      searchTerm,
      items: filteredUsers
    }
  };
};

const submitUserSuccess = (state, { submittedUser }) => {
  let users = [...state.allUsers.items];
  let updatedUserIndex = users.findIndex((c) => c.id === submittedUser.id);


  if(submittedUser.status !== 1){
    debugger;
    //Means deleted
    let deleteIndex = users.findIndex((r) => r.id === submittedUser.id);
    if (deleteIndex !== -1) {
      users.splice(deleteIndex, 1);
    }
  }
  else if(updatedUserIndex !== -1){
     //Means updated
     debugger;
    users[updatedUserIndex] = submittedUser;
  }
  
  else {
    //Means newly created
    debugger;
    users = [...users, submittedUser];
  }

  const activeUsers = users.filter((c) => c.status === 1);

  return {
    ...state,
    allUsers: {
      ...state.allUsers,
      items: activeUsers,
      itemsCopy: activeUsers
    }
  };
};

export default handleActions(
  {
    [types.SET_LOGGED_IN_USER]: setLoggedInUser,

    [types.OPEN_CHANGE_PASSWORD_DIALOG]: openChangePasswordDialog,

    [types.START_SEND_CHANGE_PASSWORD_REQUEST]: startSendChangePasswordRequest,
    [types.SEND_CHANGE_PASSWORD_REQUEST_SUCCESS]: sendChangePasswordRequestSuccess,
    [types.SEND_CHANGE_PASSWORD_REQUEST_FAILURE]: sendChangePasswordRequestFailure,
    [types.SEND_CHANGE_PASSWORD_REQUEST_FINISHED]: sendChangePasswordRequestFinished,

    [types.START_FETCH_USER_DETAILS]: startFetchUserDetails,
    [types.FETCH_USER_DETAILS_SUCCESS]: fetchUserDetailsSuccess,
    [types.FETCH_USER_DETAILS_FAILURE]: fetchUserDetailsFailure,
    [types.FETCH_USER_DETAILS_FINISHED]: fetchUserDetailsFinished,

    [types.START_FETCH_ALL_USERS]: startFetchAllUsers,
    [types.FETCH_ALL_USERS_SUCCESS]: fetchAllUsersSuccess,
    [types.FETCH_ALL_USERS_FAILURE]: fetchAllUsersFailure,
    [types.FETCH_ALL_USERS_FINISHED]: fetchAllUsersFinished,

    [types.CHANGE_SEARCH_TERM_ALL_USERS]: changeSearchTermForAllUsers,
    [types.SUBMIT_USER_SUCCESS]: submitUserSuccess
  },
  INITIAL_STATE
);
